import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'app-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    //Material
    MatDialogModule,
    MatButtonModule,
  ],
})
export class DialogConfirmComponent {
  private readonly _dialogRef = inject(MatDialogRef<DialogConfirmComponent>)
  data = inject(MAT_DIALOG_DATA) as {
    title: string
    message: string
    cancelText: string
    confirmText: string
  }
  constructor() {
    this.data.cancelText = this.data.cancelText ?? 'Cancel'
    this.data.confirmText = this.data.confirmText ?? 'Confirm'
  }

  onConfirm(): void {
    this._dialogRef.close(true)
  }
}
